import Reference from './Reference';

export default class ReferenceLogItemModel {
  constructor(data = {}) {
    this.reference = new Reference(data.reference);
    this.color = data.color || 'grey';
    this.selectedColor = data.selectedColor || 'primary';
    this.textClass = data.textClass || 'white--text';
    this.selectedTextClass = data.selectedTextClass || 'white--text';
    this.icon = data.icon;
    this.iconColor = data.iconColor;
    this.selectedIconColor = data.selectedIconColor;
  }
}
